import { QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { SimuladorStateProvider } from '../model/state';
import { Settings } from 'luxon';
import { QueryClient } from '@tanstack/react-query';

const BaseQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: () => false,
      retryDelay: 2500,
    },
  },
});

export function SimuladorSolarProvider({ children }) {
  useEffect(() => {
    Settings.defaultZone = 'America/Sao_Paulo';
    Settings.defaultLocale = 'pt-BR';
  }, []);

  return (
    <QueryClientProvider client={BaseQueryClient}>
      <SimuladorStateProvider>{children}</SimuladorStateProvider>
    </QueryClientProvider>
  );
}
